var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageSvhFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 136,
    viewBox: "0 0 271 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1102_5281)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6647 5C22.7543 5 17.1524 10.602 17.1524 17.5123V31.7522L4.96529 31.7522C4.24356 31.7522 3.83174 32.4981 4.29539 32.9656L17.1524 45.9281V115.488C17.1524 122.398 22.7543 128 29.6647 128H250.488C257.398 128 263 122.398 263 115.488V17.5123C263 10.602 257.398 5 250.488 5H29.6647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1524 31.7522L17.1524 32.9253L18.3254 32.9253V31.7522H17.1524ZM4.96529 31.7522L4.96529 32.9252H4.96529L4.96529 31.7522ZM4.29539 32.9656L3.46255 33.7916L4.29539 32.9656ZM17.1524 45.9281H18.3254V45.4451L17.9852 45.1021L17.1524 45.9281ZM18.3254 17.5123C18.3254 11.2498 23.4022 6.17303 29.6647 6.17303V3.82697C22.1065 3.82697 15.9794 9.9541 15.9794 17.5123H18.3254ZM18.3254 31.7522V17.5123H15.9794V31.7522H18.3254ZM4.96529 32.9252L17.1524 32.9253L17.1524 30.5792L4.9653 30.5792L4.96529 32.9252ZM5.12823 32.1395C5.19105 32.2029 5.25317 32.3106 5.26859 32.4472C5.28306 32.5754 5.25134 32.6806 5.21274 32.7506C5.13576 32.89 5.0195 32.9252 4.96529 32.9252L4.9653 30.5792C4.18935 30.5792 3.50632 30.9874 3.15891 31.6166C2.79697 32.2722 2.82879 33.1527 3.46255 33.7916L5.12823 32.1395ZM17.9852 45.1021L5.12823 32.1395L3.46255 33.7916L16.3195 46.7542L17.9852 45.1021ZM18.3254 115.488V45.9281H15.9794V115.488H18.3254ZM29.6647 126.827C23.4022 126.827 18.3254 121.75 18.3254 115.488H15.9794C15.9794 123.046 22.1065 129.173 29.6647 129.173V126.827ZM250.488 126.827H29.6647V129.173H250.488V126.827ZM261.827 115.488C261.827 121.75 256.75 126.827 250.488 126.827V129.173C258.046 129.173 264.173 123.046 264.173 115.488H261.827ZM261.827 17.5123V115.488H264.173V17.5123H261.827ZM250.488 6.17303C256.75 6.17303 261.827 11.2498 261.827 17.5123H264.173C264.173 9.95411 258.046 3.82697 250.488 3.82697V6.17303ZM29.6647 6.17303H250.488V3.82697H29.6647V6.17303Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1102_5281",
    x: -3.32955,
    y: -2.42913,
    width: 273.759,
    height: 137.858,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.12808
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.365319 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1102_5281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1102_5281",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSvhFive);
export default __webpack_public_path__ + "static/media/message_svh_five.ad210ad476805c82794ea731be81f23d.svg";
export { ForwardRef as ReactComponent };